import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiCard, { CardProps } from '@material-ui/core/Card';

const styles = {
  root: {
    height: '100%',
    backgroundColor: 'transparent',
  },
};

const Card = ({ classes, ...props }: CardProps) => (
  <MuiCard elevation={0} {...props} classes={classes} />
);

export default withStyles(styles)(Card);
